import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { useMemo } from "react";

export function useCredentialRequirementConfiguration() {
  const configuration = useCbhFlag(CbhFeatureFlag.CREDENTIAL_REQUIREMENTS_CONFIGURATION, {
    defaultValue: [],
  });

  return useMemo(() => new Set(configuration), [configuration]);
}
